import React, { Fragment, useState, useEffect } from "react";
import styles from "Components/Topology/topology.module.scss";
import { Form, Select, Row, Col, Tag, Input, Divider, InputNumber, Tooltip, FormInstance } from "antd";
import { CharacterVerify } from "Utility/RegExp";
import { useAppSelector, useAppDispatch } from "store/hook";
import { setLTELimitDisabled, setLTE2LimitDisabled } from "Components/Topology/store/topologySlice";
import { BsFileEarmarkBreak } from "react-icons/bs";
import { setFields } from "./setFields";

const { Option } = Select;
const { CheckableTag } = Tag;

const BulkConfigFLte_M350 = React.memo(
  ({ SubmitConfigonFinish, form }: { SubmitConfigonFinish: (value: any) => void; form: FormInstance<any> }) => {
    const tagsData = ["SIM1", "SIM2"];
    const disp = useAppDispatch();
    const [LTE1PinEnable, setLTE1PinEnable] = useState(false);
    const [LTE2PinEnable, setLTE2PinEnable] = useState(false);
    // const [LTERecoverAPN1, setLTERecoverAPN1] = useState(false);
    const [LTE1DataLimitEnable, setLTE1DataLimitEnable] = useState(false);
    const [LTE2DataLimitEnable, setLTE2DataLimitEnable] = useState(false);
    const { formData, importSource, LTELimitDisabled, LTE2LimitDisabled } = useAppSelector((state) => state.topology);
    const [SelectedSIM, setSelectedSIM] = useState("SIM1");
    const lte = formData?.lte;

    useEffect(() => {
      //jusge if dual sim

      // setSelectedSIM("SIM1");
      // if (lte?.sim?.length === 1) {
      //   disp(setShowDualSim(false));
      // } else {
      //   disp(setShowDualSim(true));
      // }

      setLTE1PinEnable(lte?.sim?.[0]?.pin_enabled || false);
      setLTE2PinEnable(lte?.sim?.[1]?.pin_enabled || false);
      // setLTERecoverAPN1(lte?.policy.recovery?.recover_apn?.enabled);
      setLTE1DataLimitEnable(lte?.limit?.[0]?.enabled);
      setLTE2DataLimitEnable(lte?.limit?.[1]?.enabled || false);

      disp(setLTELimitDisabled(false));
      disp(setLTE2LimitDisabled(false));

      if (importSource === "NewConfig") {
        return;
      }
      // setFields(lte, form);
      form.setFieldsValue({
        LTE_mode: lte?.config?.mode || "auto",
        LTE_mtu: lte?.config?.mtu || 1500,
        LTE1_pin_enabled: lte?.sim?.[0]?.pin_enabled || false,
        // LTE1_pin: lte?.sim?.[0]?.pin || "",
        // LTE1_puk: lte?.sim?.[0]?.puk || "",
        LTE1_apn1: lte?.sim?.[0]?.apn?.[0]?.apn,
        LTE1_apn1_ipv6_enabled: lte?.sim?.[0]?.apn?.[0]?.ipv6_enabled || false,
        LTE1_apn1_auth: lte?.sim?.[0]?.apn?.[0]?.auth?.type || "none",
        LTE1_apn1_username: lte?.sim?.[0]?.apn?.[0]?.auth?.username,

        // LTE2_pin: lte?.sim?.[0]?.pin || "",
        // LTE2_puk: lte?.sim?.[0]?.puk || "",
        LTE1_apn2: lte?.sim?.[0]?.apn?.[1]?.apn,
        LTE1_apn2_ipv6_enabled: lte?.sim?.[0]?.apn?.[1]?.ipv6_enabled || false,
        LTE1_apn2_auth: lte?.sim?.[0]?.apn?.[1]?.auth?.type || "none",
        LTE1_apn2_username: lte?.sim?.[0]?.apn?.[1]?.auth?.username,

        LTE2_pin_enabled: lte?.sim?.[1]?.pin_enabled || false,
        LTE2_apn1: lte?.sim?.[1]?.apn?.[0]?.apn,
        LTE2_apn1_ipv6_enabled: lte?.sim?.[0]?.apn?.[0]?.ipv6_enabled || false,
        LTE2_apn1_auth: lte?.sim?.[1]?.apn?.[0]?.auth?.type || "none",
        LTE2_apn1_username: lte?.sim?.[1]?.apn?.[0]?.auth?.username,

        LTE2_apn2: lte?.sim?.[1]?.apn?.[1]?.apn,
        LTE2_apn2_ipv6_enabled: lte?.sim?.[0]?.apn?.[1]?.ipv6_enabled || false,
        LTE2_apn2_auth: lte?.sim?.[1]?.apn?.[1]?.auth?.type || "none",
        LTE2_apn2_username: lte?.sim?.[1]?.apn?.[1]?.auth?.username,

        LTE1_limit_mbyte: lte?.limit?.[0]?.limit_mbyte,
        LTE1_limit_enabled: lte?.limit?.[0]?.enabled || false,
        LTE1_reset_day: lte?.limit?.[0]?.reset?.day || 31,
        LTE1_reset_hour: lte?.limit?.[0]?.reset?.hour || 23,
        LTE1_reset_minute: lte?.limit?.[0]?.reset?.minute || 0,
        LTE1_reset_second: lte?.limit?.[0]?.reset?.second || 0,
        LTE2_limit_mbyte: lte?.limit?.[1]?.limit_mbyte,
        LTE2_limit_enabled: lte?.limit?.[1]?.enabled || false,
        LTE2_reset_day: lte?.limit?.[1]?.reset?.day || 31,
        LTE2_reset_hour: lte?.limit?.[1]?.reset?.hour || 23,
        LTE2_reset_minute: lte?.limit?.[1]?.reset?.minute || 0,
        LTE2_reset_second: lte?.limit?.[1]?.reset?.second || 0,
        LTE_roaming: lte?.policy?.roaming || false,
        LTE_connect_retry_num: lte?.policy?.connect_retry_num || 3,
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);

    function handleTagChange(value: any) {
      setSelectedSIM(value);
    }
    return (
      <Form onFinish={SubmitConfigonFinish} form={form} scrollToFirstError layout="vertical">
        <div className="formwrap">
          <Row gutter={24} justify="space-around">
            <Col xs={24} sm={24} md={24} lg={10}>
              <h2>Ethernet</h2>
              <Divider className={styles.divider} />
              <Form.Item
                name="LTE_mode"
                label="LTE Config"
                rules={[{ required: true, message: "required!" }]}
                initialValue={"auto"}
                // tooltip={"Select connection a band"}
              >
                <Select placeholder={"Auto/2G/3G/4G..."}>
                  <Option key={0} value={"auto"}>
                    Auto
                  </Option>
                  <Option key={1} value={"2G-only"}>
                    2G-only
                  </Option>
                  <Option key={3} value={"3G-only"}>
                    3G-only
                  </Option>
                  <Option key={4} value={"4G-only"}>
                    4G-only
                  </Option>
                </Select>
              </Form.Item>
              <Form.Item
                name={"LTE_mtu"}
                label="MTU"
                rules={[
                  { required: true, message: "required!" },
                  {
                    type: "number",
                    max: 1500,
                    min: 700,
                    message: "MTU range should be 700-1500 ",
                  },
                ]}
                initialValue={1500}
                // tooltip={
                //   "MTU is the Maximum Transmission Unit that can be sent over the LTE interface. It allows user to adjust the MTU size to fit into their existing network environment."
                // }
              >
                <InputNumber placeholder={"700 ~ 1500"} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={10}>
              <h2>APN Config</h2>
              <Divider className={styles.divider} />
              {tagsData.map((tag) => (
                <CheckableTag key={tag} checked={SelectedSIM.indexOf(tag) > -1} onChange={() => handleTagChange(tag)}>
                  {tag}
                </CheckableTag>
              ))}
              {<h3></h3>}
              {/* <h3>SIM Configuration</h3> */}
              {/* <Form.Item
                name={"LTE1_pin_enabled"}
                label="PIN Enable"
                rules={[{ required: true, message: "required!" }]}
                style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                initialValue={false}
                // tooltip={"Enable to display SIM PIN setting"}
              >
                <Select
                  onChange={(value: any) => {
                    setLTE1PinEnable(value);
                  }}
                  placeholder={"ON/OFF"}
                >
                  {/* @ts-ignore */}{" "}
              {/*
                  <Option key={0} value={true}>
                    ON
                  </Option>
                  {/* @ts-ignore */}{" "}
              {/*
                  <Option key={1} value={false}>
                    OFF
                  </Option>
                </Select>
              </Form.Item> */}
              {/* {LTE1PinEnable && (
                <Fragment>
                  <Form.Item
                    name={"LTE1_pin"}
                    label="PIN"
                    rules={[
                      CharacterVerify,
                      {
                        pattern: /^[0-9]{4}$/,
                        message: "Invalid!!",
                      },
                    ]}
                    style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                    // tooltip={"Personal Identification Number(PIN) is use to protect your SIM card."}
                  >
                    <Input.Password autoComplete="new-password" placeholder={"******"} />
                  </Form.Item>
                  <Form.Item
                    name={"LTE1_puk"}
                    label="PUK"
                    //rules={[CharacterVerify]}
                    rules={[
                      CharacterVerify,
                      {
                        required: true,
                        message: "required!",
                      },
                    ]}
                    style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                    // tooltip={
                    //   "If user input the wrong SIM PIN more than 3 times, the user needs another password personal unblocking code (PUK) for PIN unlocking. Please check your operator for forgotten PUK number."
                    // }
                  >
                    <Input.Password autoComplete="new-password" maxLength={30} placeholder={"******"} />
                  </Form.Item>
                </Fragment>
              )} */}
              {/* <Form.Item
                name={"LTE2_pin_enabled"}
                label="PIN Enable"
                initialValue={false}
                style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
              >
                <Select
                  onChange={(value: any) => {
                    setLTE2PinEnable(value);
                  }}
                  placeholder={"ON/OFF"}
                >
                  {/* @ts-ignore */}{" "}
              {/*
                  <Option key={0} value={true}>
                    ON
                  </Option>
                  {/* @ts-ignore */}{" "}
              {/*
                  <Option key={1} value={false}>
                    OFF
                  </Option>
                </Select>
              </Form.Item> */}
              {/* {LTE2PinEnable && (
                <Fragment>
                  <Form.Item
                    name={"LTE2_pin"}
                    label="PIN"
                    rules={[
                      CharacterVerify,
                      {
                        pattern: /^[0-9]{4}$/,
                        message: "Invalid!!",
                      },
                    ]}
                    style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                  >
                    <Input.Password autoComplete="new-password" maxLength={30} placeholder={"******"} />
                  </Form.Item>
                  <Form.Item
                    name={"LTE2_puk"}
                    label="PUK"
                    //rules={[CharacterVerify]}
                    rules={[
                      CharacterVerify,
                      {
                        required: true,
                        message: "required!",
                      },
                    ]}
                    style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                  >
                    <Input.Password autoComplete="new-password" maxLength={30} placeholder={"******"} />
                  </Form.Item>
                </Fragment>
              )} */}
              <div style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}>
                <h3>APN1</h3>
                <Form.Item
                  name={"LTE1_apn1"}
                  label="APN"
                  rules={[CharacterVerify]}
                  // tooltip={
                  //   "The Access Point Name (APN) is the name for the settings to set up a connection to the gateway between your carrier's cellular network and the Public Internet. Leaving it empty will search internally database automatically by SIM card for connection."
                  // }
                >
                  <Input placeholder={"APN Name"} maxLength={30} />
                </Form.Item>
                <Form.Item name={"LTE1_apn1_username"} label="User Name" rules={[CharacterVerify]}>
                  <Input placeholder={"Name"} maxLength={30} />
                </Form.Item>
                <Form.Item name={"LTE1_apn1_password"} label="Password" rules={[CharacterVerify]}>
                  <Input placeholder={"Password"} maxLength={30} />
                </Form.Item>
                <Form.Item
                  name="LTE1_apn1_auth"
                  label="Auth Type"
                  initialValue={"none"}
                  // tooltip={"If Auth mode is not None, most servers require username and password above."}
                >
                  <Select placeholder={"PAP/CHAP"}>
                    <Option key={0} value={"none"}>
                      NONE
                    </Option>
                    <Option key={1} value={"pap"}>
                      PAP
                    </Option>
                    <Option key={3} value={"chap"}>
                      CHAP
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item name={"LTE1_apn1_ipv6_enabled"} label="Enable IPv6" initialValue={false}>
                  <Select placeholder={"ON/OFF"}>
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      ON
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>
              </div>
              <div style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}>
                <h3>APN2</h3>
                <Form.Item
                  name={"LTE1_apn2"}
                  label="APN"
                  rules={[CharacterVerify]}
                  // tooltip={
                  //   "The Access Point Name (APN) is the name for the settings to set up a connection to the gateway between your carrier's cellular network and the Public Internet. Leaving it empty will search internally database automatically by SIM card for connection."
                  // }
                >
                  <Input placeholder={"APN Name"} maxLength={30} />
                </Form.Item>
                <Form.Item name={"LTE1_apn2_username"} label="User Name" rules={[CharacterVerify]}>
                  <Input placeholder={"Name"} maxLength={30} />
                </Form.Item>
                <Form.Item name={"LTE1_apn2_password"} label="Password" rules={[CharacterVerify]}>
                  <Input placeholder={"Password"} maxLength={30} />
                </Form.Item>
                <Form.Item
                  name="LTE1_apn2_auth"
                  label="Auth Type"
                  initialValue={"none"}
                  // tooltip={"If Auth mode is not None, most servers require username and password above."}
                >
                  <Select placeholder={"PAP/CHAP"}>
                    <Option key={0} value={"none"}>
                      NONE
                    </Option>
                    <Option key={1} value={"pap"}>
                      PAP
                    </Option>
                    <Option key={3} value={"chap"}>
                      CHAP
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item name={"LTE1_apn2_ipv6_enabled"} label="Enable IPv6" initialValue={false}>
                  <Select placeholder={"ON/OFF"}>
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      ON
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>
              </div>
              <div style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}>
                <h3>APN1</h3>
                <Form.Item name={"LTE2_apn1"} label="APN" rules={[CharacterVerify]}>
                  <Input placeholder={"APN Name"} maxLength={30} />
                </Form.Item>
                <Form.Item name={"LTE2_apn1_username"} label="User Name" rules={[CharacterVerify]}>
                  <Input placeholder={"Name"} maxLength={30} />
                </Form.Item>
                <Form.Item name={"LTE2_apn1_password"} label="Password" rules={[CharacterVerify]}>
                  <Input placeholder={"Password"} maxLength={30} />
                </Form.Item>
                <Form.Item name="LTE2_apn1_auth" label="Auth Type" initialValue={"none"}>
                  <Select placeholder={"PAP/CHAP"}>
                    <Option key={0} value={"none"}>
                      NONE
                    </Option>
                    <Option key={1} value={"pap"}>
                      PAP
                    </Option>
                    <Option key={3} value={"chap"}>
                      CHAP
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item name={"LTE2_apn1_ipv6_enabled"} label="Enable IPv6" initialValue={false}>
                  <Select placeholder={"ON/OFF"}>
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      ON
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>
              </div>
              <div style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}>
                <h3>APN2</h3>
                <Form.Item
                  name={"LTE2_apn2"}
                  label="APN"
                  rules={[CharacterVerify]}
                  // tooltip={
                  //   "The Access Point Name (APN) is the name for the settings to set up a connection to the gateway between your carrier's cellular network and the Public Internet. Leaving it empty will search internally database automatically by SIM card for connection."
                  // }
                >
                  <Input placeholder={"APN Name"} maxLength={30} />
                </Form.Item>
                <Form.Item name={"LTE2_apn2_username"} label="User Name" rules={[CharacterVerify]}>
                  <Input placeholder={"Name"} maxLength={30} />
                </Form.Item>
                <Form.Item name={"LTE2_apn2_password"} label="Password" rules={[CharacterVerify]}>
                  <Input placeholder={"Password"} maxLength={30} />
                </Form.Item>
                <Form.Item
                  name="LTE2_apn2_auth"
                  label="Auth Type"
                  initialValue={"none"}
                  // tooltip={"If Auth mode is not None, most servers require username and password above."}
                >
                  <Select placeholder={"PAP/CHAP"}>
                    <Option key={0} value={"none"}>
                      NONE
                    </Option>
                    <Option key={1} value={"pap"}>
                      PAP
                    </Option>
                    <Option key={3} value={"chap"}>
                      CHAP
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item name={"LTE2_apn2_ipv6_enabled"} label="Enable IPv6" initialValue={false}>
                  <Select placeholder={"ON/OFF"}>
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      ON
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>
              </div>
              <h3>Data Limitation</h3>
              <Form.Item
                name={"LTE1_limit_enabled"}
                label="Limit Enabled"
                style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                rules={[{ required: true, message: "required!" }]}
                initialValue={false}
                // tooltip={"Enable to set up the data limitation/ reset time "}
              >
                <Select
                  onChange={(value: any) => {
                    setLTE1DataLimitEnable(value);
                  }}
                  placeholder={"ON/OFF"}
                >
                  {/* @ts-ignore */}
                  <Option key={0} value={true}>
                    ON
                  </Option>
                  {/* @ts-ignore */}
                  <Option key={1} value={false}>
                    OFF
                  </Option>
                </Select>
              </Form.Item>
              {LTE1DataLimitEnable && (
                <Fragment>
                  <Form.Item
                    name={"LTE1_limit_mbyte"}
                    label={
                      <span style={LTELimitDisabled ? { textDecoration: " line-through" } : {}}>
                        Max Data Limitation (MB)
                      </span>
                    }
                    rules={[{ required: LTELimitDisabled ? false : true, message: "required!" }]}
                    style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                    // onChange={(value: any) => {
                    //   if (value.target?.value < 0) {
                    //     form.setFieldsValue({ LTE1_limit_mbyte: 0 });
                    //   }
                    // }}
                  >
                    <Input
                      type="number"
                      disabled={LTELimitDisabled}
                      style={{ width: "100%" }}
                      placeholder="1"
                      min={0}
                      addonAfter={
                        <Tooltip title="Exclude this field">
                          <BsFileEarmarkBreak
                            onClick={() => {
                              disp(setLTELimitDisabled(!LTELimitDisabled));
                              form.validateFields(["LTE1_limit_mbyte"]);
                            }}
                            className={styles.excludeIcon}
                          />
                        </Tooltip>
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    name={"LTE1_reset_day"}
                    label="Reset Date"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 31,
                        min: 1,
                        message: "Reset Date should be 1-31",
                      },
                    ]}
                    style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="1~31" min={1} max={31} />
                  </Form.Item>
                  <Form.Item
                    name={"LTE1_reset_hour"}
                    label="Hour"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 23,
                        min: 0,
                        message: "Reset Hour should be 0-23",
                      },
                    ]}
                    style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="0~23" min={0} max={23} />
                  </Form.Item>
                  <Form.Item
                    name={"LTE1_reset_minute"}
                    label="Minute"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 59,
                        min: 0,
                        message: "Reset Minute should be 0-59",
                      },
                    ]}
                    style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="0~59" min={0} max={59} />
                  </Form.Item>
                  <Form.Item
                    name={"LTE1_reset_second"}
                    label="Second"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 59,
                        min: 0,
                        message: "Reset Second should be 0-59",
                      },
                    ]}
                    style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="0~59" min={0} max={59} />
                  </Form.Item>
                </Fragment>
              )}
              <Form.Item
                name={"LTE2_limit_enabled"}
                label="Limit Enabled"
                style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                initialValue={false}
              >
                <Select
                  onChange={(value: any) => {
                    setLTE2DataLimitEnable(value);
                  }}
                  placeholder={"ON/OFF"}
                >
                  {/* @ts-ignore */}
                  <Option key={0} value={true}>
                    ON
                  </Option>
                  {/* @ts-ignore */}
                  <Option key={1} value={false}>
                    OFF
                  </Option>
                </Select>
              </Form.Item>
              {LTE2DataLimitEnable && (
                <Fragment>
                  <Form.Item
                    name={"LTE2_limit_mbyte"}
                    label={
                      <span style={LTE2LimitDisabled ? { textDecoration: " line-through" } : {}}>
                        Max Data Limitation (MB)
                      </span>
                    }
                    rules={[{ required: LTE2LimitDisabled ? false : true, message: "required!" }]}
                    style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                    // onChange={(value) => {
                    //   if (value.target?.value < 0) {
                    //     form.setFieldsValue({ LTE2_limit_mbyte: 0 });
                    //   }
                    // }}
                  >
                    <Input
                      type="number"
                      disabled={LTE2LimitDisabled}
                      style={{ width: "100%" }}
                      placeholder="1"
                      min={0}
                      addonAfter={
                        <Tooltip title="Exclude this field">
                          <BsFileEarmarkBreak
                            onClick={() => {
                              disp(setLTE2LimitDisabled(!LTE2LimitDisabled));
                              form.validateFields(["LTE2_limit_mbyte"]);
                            }}
                            className={styles.excludeIcon}
                          />
                        </Tooltip>
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    name={"LTE2_reset_day"}
                    label="Reset Date"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 31,
                        min: 1,
                        message: "Reset Date should be 1-31",
                      },
                    ]}
                    style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="1~31" min={1} max={31} />
                  </Form.Item>
                  <Form.Item
                    name={"LTE2_reset_hour"}
                    label="Hour"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 23,
                        min: 0,
                        message: "Reset Hour should be 0-23",
                      },
                    ]}
                    style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="0~23" min={0} max={23} />
                  </Form.Item>
                  <Form.Item
                    name={"LTE2_reset_minute"}
                    label="Minute"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 59,
                        min: 0,
                        message: "Reset Minute should be 0-59",
                      },
                    ]}
                    style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="0~59" min={0} max={59} />
                  </Form.Item>
                  <Form.Item
                    name={"LTE2_reset_second"}
                    label="Second"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 59,
                        min: 0,
                        message: "Reset Second should be 0-59",
                      },
                    ]}
                    style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="0~59" min={0} max={59} />
                  </Form.Item>
                </Fragment>
              )}
              <h3>Connect Policy</h3>
              <Form.Item
                name={"LTE_roaming"}
                label="Roaming"
                initialValue={false}
                rules={[{ required: true, message: "required!" }]}
              >
                <Select placeholder={"ON/OFF"}>
                  {/* @ts-ignore */}
                  <Option key={0} value={true}>
                    ON
                  </Option>
                  {/* @ts-ignore */}
                  <Option key={1} value={false}>
                    OFF
                  </Option>
                </Select>
              </Form.Item>
              <Form.Item
                name={"LTE_connect_retry_num"}
                label="Connect Retry Number"
                rules={[{ required: true, message: "required!" }]}
              >
                <InputNumber style={{ width: "100%" }} placeholder="1" min={1} max={100} />
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Form>
    );
  }
);

export default BulkConfigFLte_M350;

/////////////////////////////////////////////////////////////////////////////////////////////////////////

export const assemble = (values: any, LTELimitDisabled: boolean = false, LTE2LimitDisabled: boolean = false) => {
  let simArray = [];
  //SIM1
  let sim1Obj: any = {};

  if (values.LTE1_pin_enabled !== undefined) {
    sim1Obj.pin_enabled = values.LTE1_pin_enabled;
  }

  // if (values.LTE1_pin) {
  //   sim1Obj.pin = values.LTE1_pin;
  // }

  // if (values.LTE1_puk) {
  //   sim1Obj.puk = values.LTE1_puk;
  // }

  //sim1Obj.pin_enabled = values.LTE1_pin_enabled;
  //sim1Obj.pin = values.LTE1_pin || "";
  //sim1Obj.puk = values.LTE1_puk || "";

  let LTE1_apnArray = [];

  let LTE1_apn1Obj: any = {};
  let LTE1_apn2Obj: any = {};

  LTE1_apn1Obj.apn = values.LTE1_apn1 || "";
  LTE1_apn2Obj.apn = values.LTE1_apn2 || "";

  let LTE1_Auth1Obj: any = {};
  let LTE1_Auth2Obj: any = {};

  LTE1_Auth1Obj.username = values.LTE1_apn1_username || "";
  LTE1_Auth2Obj.username = values.LTE1_apn2_username || "";

  //
  // if (values.LTE1_apn1_password) {
  //   LTE1_Auth1Obj.password = values.LTE1_apn1_password;
  // }
  // if (values.LTE1_apn2_password) {
  //   LTE1_Auth2Obj.password = values.LTE1_apn2_password;
  // }

  LTE1_Auth1Obj.password = values.LTE1_apn1_password || "";
  LTE1_Auth2Obj.password = values.LTE1_apn2_password || "";

  //
  if (values.LTE1_apn1_ipv6_enabled !== undefined) {
    LTE1_apn1Obj.ipv6_enabled = values.LTE1_apn1_ipv6_enabled;
  }
  if (values.LTE1_apn2_ipv6_enabled !== undefined) {
    LTE1_apn2Obj.ipv6_enabled = values.LTE1_apn2_ipv6_enabled;
  }
  //
  if (values.LTE1_apn1_auth) {
    LTE1_Auth1Obj.type = values.LTE1_apn1_auth;
  }
  if (values.LTE1_apn2_auth) {
    LTE1_Auth2Obj.type = values.LTE1_apn2_auth;
  }

  LTE1_apn1Obj.auth = LTE1_Auth1Obj;
  LTE1_apn2Obj.auth = LTE1_Auth2Obj;

  LTE1_apnArray.push(LTE1_apn1Obj);
  LTE1_apnArray.push(LTE1_apn2Obj);
  sim1Obj.apn = LTE1_apnArray;
  simArray.push(sim1Obj);

  //limit
  let limitArray: any = [
    {
      enabled: values.LTE1_limit_enabled,
      reset: {
        day: values.LTE1_reset_day || 31,
        hour: values.LTE1_reset_hour || 23,
        minute: values.LTE1_reset_minute || 0,
        second: values.LTE1_reset_second || 0,
      },
    },
  ];
  if (!LTELimitDisabled) {
    limitArray[0].limit_mbyte = parseInt(values.LTE1_limit_mbyte) || 0;
  }

  //SIM2

  let sim2Obj: any = {};

  // if (values.LTE2_pin) {
  // } else {
  //   sim2Obj.pin = values.LTE2_pin;
  // }

  // if (values.LTE2_puk) {
  //   sim2Obj.puk = values.LTE2_puk;
  // }

  // sim2Obj.pin = values.LTE2_pin || "";
  // sim2Obj.puk = values.LTE2_puk || "";

  // if (values.LTE2_pin_enabled !== undefined) {
  //   sim2Obj.pin_enabled = values.LTE2_pin_enabled;
  // }

  let LTE2_apnArray = [];
  let LTE2_apn1Obj: any = {};
  let LTE2_apn2Obj: any = {};

  LTE2_apn1Obj.apn = values.LTE2_apn1 || "";
  LTE2_apn2Obj.apn = values.LTE2_apn2 || "";

  if (values.LTE2_apn1_ipv6_enabled !== undefined) {
    LTE2_apn1Obj.ipv6_enabled = values.LTE2_apn1_ipv6_enabled;
  }
  if (values.LTE2_apn2_ipv6_enabled !== undefined) {
    LTE2_apn2Obj.ipv6_enabled = values.LTE2_apn2_ipv6_enabled;
  }

  let LTE2_Auth1Obj: any = {};
  let LTE2_Auth2Obj: any = {};

  LTE2_Auth1Obj.username = values.LTE2_apn1_username || "";
  LTE2_Auth2Obj.username = values.LTE2_apn2_username || "";

  // if (values.LTE2_apn1_password) {
  //   LTE2_Auth1Obj.password = values.LTE2_apn1_password;
  // }
  // if (values.LTE2_apn2_password) {
  //   LTE2_Auth2Obj.password = values.LTE2_apn2_password;
  // }

  LTE2_Auth1Obj.password = values.LTE2_apn1_password || "";
  LTE2_Auth2Obj.password = values.LTE2_apn2_password || "";

  if (values.LTE2_apn1_auth) {
    LTE2_Auth1Obj.type = values.LTE2_apn1_auth;
  }
  if (values.LTE2_apn2_auth) {
    LTE2_Auth2Obj.type = values.LTE2_apn2_auth;
  }

  LTE2_apn1Obj.auth = LTE2_Auth1Obj;
  LTE2_apn2Obj.auth = LTE2_Auth2Obj;

  LTE2_apnArray.push(LTE2_apn1Obj);
  LTE2_apnArray.push(LTE2_apn2Obj);

  sim2Obj.apn = LTE2_apnArray;

  simArray.push(sim2Obj);
  // sim2-limitation

  let limit2: any = {
    enabled: values.LTE2_limit_enabled || false,
    // limit_mbyte: values.LTE2_limit_mbyte || 0,
    reset: {
      day: values.LTE2_reset_day || 31,
      hour: values.LTE2_reset_hour || 23,
      minute: values.LTE2_reset_minute || 0,
      second: values.LTE2_reset_second || 0,
    },
  };

  if (!LTE2LimitDisabled) {
    limit2.limit_mbyte = parseInt(values.LTE2_limit_mbyte) || 0;
  }

  limitArray.push(limit2);

  const lteObj: any = {
    config: { mode: values.LTE_mode, mtu: values.LTE_mtu },
    sim: simArray,
    limit: limitArray,
    policy: {
      roaming: values.LTE_roaming,
      connect_retry_num: values.LTE_connect_retry_num,
    },
  };

  return lteObj;
};
